export default [
  {
    path: '/login',
    name: 'login',
    meta: {
      title: 'login',
      public: true,
      middleware: 'guest'
    },
    component: () => import('@/views/login/index.vue')
  },
  {
    path: '/reset-password/:token',
    props: true,
    name: 'resetPass',
    meta: {
      title: 'resetPass',
      public: true,
      middleware: 'guest'
    },
    component: () => import('@/views/login/resetPass.vue')
  },
  {
    path: '/',
    name: 'old-dashboard',
    redirect: { name: 'dashboard' },
    meta: {
      title: 'dashboard',
      middleware: 'auth',
      acl: [
        {
          name: 'dashboard',
          permission: 'view'
        }
      ]
    },
    component: () => import('@/views/Home.vue')
  },
  {
    path: '/dashboard',
    name: 'dashboard',
    meta: {
      title: 'dashboard',
      middleware: 'auth',
      acl: [
        {
          name: 'dashboard',
          permission: 'view'
        }
      ]
    },
    component: () => import('@/views/Home.vue')
  },
  {
    path: '/topline-report',
    name: 'topline',
    meta: {
      title: 'dashboard',
      middleware: 'auth',
      acl: [
        {
          name: 'topline_report',
          permission: 'view'
        }
      ]
    },
    component: () => import('@/views/topline_report/index.vue')
  },
  {
    path: '/spending/report',
    name: 'spending',
    props: true,
    meta: {
      title: 'spending',
      middleware: 'auth',
      acl: [
        {
          name: 'view_spending_report',
          permission: 'view'
        }
      ]
    },
    data: {
      year: ''
    },
    component: () => import('@/views/report/index.vue')
  },
  {
    path: '/spending/backup',
    name: 'backup-spending',
    props: true,
    meta: {
      title: 'Spending',
      middleware: 'auth',
      acl: [
        {
          name: 'view_backup_spending',
          permission: 'view'
        }
      ]
    },
    data: {
      year: ''
    },
    component: () => import('@/views/report/backup.vue')
  },
  {
    path: '/spending/approval',
    name: 'approval-dynamic',
    props: true,
    meta: {
      title: 'spending',
      middleware: 'auth',
      acl: [
        {
          name: 'approve_spending',
          permission: 'approve'
        }
      ]
    },
    data: {
      year: ''
    },
    component: () => import('@/views/report/index.vue')
  },
  {
    path: '/budgeting/report',
    name: 'budgeting-report',
    props: true,
    meta: {
      title: 'Budgeting',
      middleware: 'auth',
      acl: [
        {
          name: 'view_budget_report_a',
          permission: 'view'
        }
      ]
    },
    component: () => import('@/views/report/index.vue')
  },
  {
    path: '/spending/report/search/:yearIo/:io/:boIo',
    name: 'searchSpending',
    props: true,
    meta: {
      title: 'spending',
      middleware: 'auth',
      acl: [
        {
          name: 'view_spending_report',
          permission: 'view'
        }
      ]
    },
    data: {
      year: ''
    },
    component: () => import('@/views/report/index.vue')
  },
  {
    path: '/spending/report/detail/:code',
    name: 'spendingTaxo',
    props: true,
    meta: {
      title: 'spending',
      middleware: 'auth',
      acl: [
        {
          name: 'view_spending_report',
          permission: 'view'
        }
      ]
    },
    component: () => import('@/views/spending/detail_taxo')
  },
  {
    path: '/spending/consolidated/:yearFilter',
    name: 'consolidated-report',
    props: true,
    meta: {
      title: 'spending',
      middleware: 'auth',
      acl: [
        {
          name: 'view_spending_report',
          permission: 'view'
        }
      ]
    },
    component: () => import('@/views/spending/consolidated')
  },
  {
    path: '/spending/upload-bi',
    name: 'upload-bi',
    meta: {
      title: 'integration',
      middleware: 'auth',
      acl: [
        {
          name: 'po_upload',
          permission: 'create'
        }
      ]
    },
    component: () => import('@/views/spending/spending_report/upload_sap.vue')
  },
  {
    path: '/spending/report/create',
    name: 'spendingCreate',
    meta: {
      title: 'spending',
      middleware: 'auth',
      acl: [
        {
          name: 'create_spending',
          permission: 'create'
        }
      ]
    },
    component: () => import('@/views/spending/spending_report/form.vue')
  },
  {
    path: '/spending/report/revise/:id/:flow',
    props: true,
    name: 'reviseUpload',
    meta: {
      title: 'spending',
      middleware: 'auth',
      acl: [
        {
          name: 'create_spending',
          permission: 'create'
        }
      ]
    },
    component: () => import('@/views/spending/spending_report/form.vue')
  },
  {
    path: '/spending/approval/search/:yearIo/:io/:boIo',
    name: 'searchApproval',
    props: true,
    meta: {
      title: 'spending',
      middleware: 'auth',
      acl: [
        {
          name: 'approve_spending',
          permission: 'approve'
        }
      ]
    },
    component: () => import('@/views/report/index.vue')
  },
  {
    path: '/spending/approval-verification/search/:yearIo',
    name: 'redirectApproval',
    props: true,
    meta: {
      title: 'spending',
      middleware: 'auth',
      acl: [
        {
          name: 'approve_spending',
          permission: 'approve'
        }
      ]
    },
    component: () => import('@/views/spending/spending_report/approval.vue')
  },
  {
    path: '/spending/report/:id/:submitable',
    name: 'one-pager',
    props: true,
    meta: {
      title: 'spending',
      middleware: 'auth',
      acl: [
        {
          name: 'view_spending_report',
          permission: 'view'
        }
      ]
    },
    component: () => import('@/views/spending/one_pager/index.vue')
  },
  {
    path: '/po-monitoring/po-report',
    name: 'po-report',
    meta: {
      title: 'PO & Non PO Monitoring',
      middleware: 'auth',
      acl: [
        {
          name: 'po_monitoring',
          permission: 'view'
        }
      ]
    },
    component: () => import('@/views/po_monitoring/po_report/index.vue')
  },
  {
    path: '/po-monitoring/po-report/search/:yearIo/:io',
    name: 'searchPO',
    props: true,
    meta: {
      title: 'PO & Non PO Monitoring',
      middleware: 'auth',
      acl: [
        {
          name: 'po_monitoring',
          permission: 'view'
        }
      ]
    },
    component: () => import('@/views/po_monitoring/po_report/index.vue')
  },
  {
    path: '/po-monitoring/non-po-report',
    name: 'non-po',
    meta: {
      title: 'PO & Non PO Monitoring',
      middleware: 'auth',
      acl: [
        {
          name: 'po_monitoring',
          permission: 'view'
        }
      ]
    },
    component: () => import('@/views/po_monitoring/non_po/index.vue')
  },
  {
    path: '/po-monitoring/non-po-report/search/:yearIo/:io',
    name: 'searchNonPO',
    props: true,
    meta: {
      title: 'PO & Non PO Monitoring',
      middleware: 'auth',
      acl: [
        {
          name: 'po_monitoring',
          permission: 'view'
        }
      ]
    },
    component: () => import('@/views/po_monitoring/non_po/index.vue')
  },
  {
    path: '/po-monitoring/history-log-upload',
    name: 'history-log-upload',
    meta: {
      title: 'PO & Non PO Monitoring',
      middleware: 'auth',
      acl: [
        {
          name: 'history_log',
          permission: 'view'
        }
      ]
    },
    component: () => import('@/views/po_monitoring/history_log/index.vue')
  },
  {
    path: '/master_data/channel',
    name: 'channel',
    meta: {
      title: 'master data',
      middleware: 'auth',
      acl: [
        {
          name: 'view_master_data',
          permission: 'view'
        }
      ]
    },
    component: () => import('@/views/master_data/channel/index.vue')
  },
  {
    path: '/master_data/position',
    name: 'position',
    meta: {
      title: 'master data',
      middleware: 'auth',
      acl: [
        {
          name: 'view_master_data',
          permission: 'view'
        }
      ]
    },
    component: () => import('@/views/master_data/position/index.vue')
  },
  {
    path: '/master_data/entity',
    name: 'entity',
    meta: {
      title: 'master data',
      middleware: 'auth',
      acl: [
        {
          name: 'view_master_data',
          permission: 'view'
        }
      ]
    },
    component: () => import('@/views/master_data/entity/index.vue')
  },
  {
    path: '/master_data/department',
    name: 'department',
    meta: {
      title: 'master data',
      middleware: 'auth',
      acl: [
        {
          name: 'view_master_data',
          permission: 'view'
        }
      ]
    },
    component: () => import('@/views/master_data/department/index.vue')
  },
  {
    path: '/master_data/department/detail/:id',
    name: 'departmentDetail',
    props: true,
    meta: {
      title: 'master data',
      middleware: 'auth',
      acl: [
        {
          name: 'view_master_data',
          permission: 'view'
        }
      ]
    },
    component: () => import('@/views/master_data/department/detail.vue')
  },
  {
    path: '/master_data/department/create',
    name: 'departmentCreate',
    meta: {
      title: 'master data',
      middleware: 'auth',
      acl: [
        {
          name: 'create_master_data',
          permission: 'create'
        }
      ]
    },
    component: () => import('@/views/master_data/department/form.vue')
  },
  {
    path: '/master_data/department/edit/:id',
    name: 'departmentEdit',
    props: true,
    meta: {
      title: 'master data',
      middleware: 'auth',
      acl: [
        {
          name: 'update_master_data',
          permission: 'update'
        }
      ]
    },
    component: () => import('@/views/master_data/department/form.vue')
  },
  {
    path: '/master_data/brand',
    name: 'brand',
    meta: {
      title: 'master data',
      middleware: 'auth',
      acl: [
        {
          name: 'view_master_data',
          permission: 'view'
        }
      ]
    },
    component: () => import('@/views/master_data/brand/index.vue')
  },
  {
    path: '/master_data/brand/detail/:id',
    name: 'brandDetail',
    props: true,
    meta: {
      title: 'master data',
      middleware: 'auth',
      acl: [
        {
          name: 'view_master_data',
          permission: 'view'
        }
      ]
    },
    component: () => import('@/views/master_data/brand/detail.vue')
  },
  {
    path: '/master_data/brand/create',
    name: 'brandCreate',
    meta: {
      title: 'master data',
      middleware: 'auth',
      acl: [
        {
          name: 'create_master_data',
          permission: 'create'
        }
      ]
    },
    component: () => import('@/views/master_data/brand/form.vue')
  },
  {
    path: '/master_data/brand/edit/:id',
    name: 'brandEdit',
    props: true,
    meta: {
      title: 'master data',
      middleware: 'auth',
      acl: [
        {
          name: 'update_master_data',
          permission: 'update'
        }
      ]
    },
    component: () => import('@/views/master_data/brand/form.vue')
  },
  {
    path: '/master_data/house',
    name: 'house',
    meta: {
      title: 'master data',
      middleware: 'auth',
      acl: [
        {
          name: 'view_master_data',
          permission: 'view'
        }
      ]
    },
    component: () => import('@/views/master_data/house/index.vue')
  },
  {
    path: '/master_data/taxonomy',
    name: 'taxonomy',
    meta: {
      title: 'master data',
      middleware: 'auth',
      acl: [
        {
          name: 'view_master_data',
          permission: 'view'
        }
      ]
    },
    component: () => import('@/views/master_data/taxonomy/index.vue')
  },
  {
    path: '/master_data/taxonomy/create',
    name: 'taxonomyCreate',
    meta: {
      title: 'master data',
      middleware: 'auth',
      acl: [
        {
          name: 'create_master_data',
          permission: 'create'
        }
      ]
    },
    component: () => import('@/views/master_data/taxonomy/form.vue')
  },
  {
    path: '/master_data/taxonomy/detail/:id',
    name: 'taxonomyDetail',
    props: true,
    meta: {
      title: 'master data',
      middleware: 'auth',
      acl: [
        {
          name: 'view_master_data',
          permission: 'view'
        }
      ]
    },
    component: () => import('@/views/master_data/taxonomy/detail.vue')
  },
  {
    path: '/master_data/taxonomy/edit/:id',
    name: 'taxonomyEdit',
    props: true,
    meta: {
      title: 'master data',
      middleware: 'auth',
      acl: [
        {
          name: 'update_master_data',
          permission: 'update'
        }
      ]
    },
    component: () => import('@/views/master_data/taxonomy/form.vue')
  },
  {
    path: '/master_data/product_hierarchy',
    name: 'productHierarchy',
    meta: {
      title: 'master data',
      middleware: 'auth',
      acl: [
        {
          name: 'view_master_data',
          permission: 'view'
        }
      ]
    },
    component: () => import('@/views/master_data/product_hierarchy/index.vue')
  },
  {
    path: '/master_data/product_hierarchy/create',
    name: 'hierarchyCreate',
    meta: {
      title: 'master data',
      middleware: 'auth',
      acl: [
        {
          name: 'create_master_data',
          permission: 'create'
        }
      ]
    },
    component: () => import('@/views/master_data/product_hierarchy/form.vue')
  },
  {
    path: '/master_data/product_hierarchy/detail/:id',
    name: 'hierarchyDetail',
    props: true,
    meta: {
      title: 'master data',
      middleware: 'auth',
      acl: [
        {
          name: 'view_master_data',
          permission: 'view'
        }
      ]
    },
    component: () => import('@/views/master_data/product_hierarchy/detail.vue')
  },
  {
    path: '/master_data/product_hierarchy/edit/:id',
    name: 'hierarchyEdit',
    props: true,
    meta: {
      title: 'master data',
      middleware: 'auth',
      acl: [
        {
          name: 'update_master_data',
          permission: 'update'
        }
      ]
    },
    component: () => import('@/views/master_data/product_hierarchy/form.vue')
  },
  {
    path: '/master_data/cost_center',
    name: 'costCenter',
    meta: {
      title: 'master data',
      middleware: 'auth',
      acl: [
        {
          name: 'view_master_data',
          permission: 'view'
        }
      ]
    },
    component: () => import('@/views/master_data/cost_center/index.vue')
  },
  {
    path: '/master_data/cost_center/create',
    name: 'costCenterCreate',
    meta: {
      title: 'master data',
      middleware: 'auth',
      acl: [
        {
          name: 'create_master_data',
          permission: 'create'
        }
      ]
    },
    component: () => import('@/views/master_data/cost_center/form.vue')
  },
  {
    path: '/master_data/cost_center/detail/:id',
    name: 'costCenterDetail',
    props: true,
    meta: {
      title: 'master data',
      middleware: 'auth',
      acl: [
        {
          name: 'view_master_data',
          permission: 'view'
        }
      ]
    },
    component: () => import('@/views/master_data/cost_center/detail.vue')
  },
  {
    path: '/master_data/cost_center/edit/:id',
    name: 'costCenterEdit',
    props: true,
    meta: {
      title: 'master data',
      middleware: 'auth',
      acl: [
        {
          name: 'update_master_data',
          permission: 'update'
        }
      ]
    },
    component: () => import('@/views/master_data/cost_center/form.vue')
  },
  {
    path: '/master_data/cost_element',
    name: 'costElement',
    meta: {
      title: 'master data',
      middleware: 'auth',
      acl: [
        {
          name: 'view_master_data',
          permission: 'view'
        }
      ]
    },
    component: () => import('@/views/master_data/cost_element/index.vue')
  },
  {
    path: '/master_data/cost_element/create',
    name: 'costElementCreate',
    meta: {
      title: 'master data',
      middleware: 'auth',
      acl: [
        {
          name: 'create_master_data',
          permission: 'create'
        }
      ]
    },
    component: () => import('@/views/master_data/cost_element/form.vue')
  },
  {
    path: '/master_data/cost_element/detail/:id',
    name: 'costElementDetail',
    props: true,
    meta: {
      title: 'master data',
      middleware: 'auth',
      acl: [
        {
          name: 'view_master_data',
          permission: 'view'
        }
      ]
    },
    component: () => import('@/views/master_data/cost_element/detail.vue')
  },
  {
    path: '/master_data/cost_element/edit/:id',
    name: 'costElementEdit',
    props: true,
    meta: {
      title: 'master data',
      middleware: 'auth',
      acl: [
        {
          name: 'update_master_data',
          permission: 'update'
        }
      ]
    },
    component: () => import('@/views/master_data/cost_element/form.vue')
  },
  {
    path: '/master_data/cost_consumer',
    name: 'costConsumer',
    meta: {
      title: 'master data',
      middleware: 'auth',
      acl: [
        {
          name: 'view_master_data',
          permission: 'view'
        }
      ]
    },
    component: () => import('@/views/master_data/cost_consumer/index.vue')
  },
  {
    path: '/master_data/cost_consumer/create',
    name: 'costConsumerCreate',
    meta: {
      title: 'master data',
      middleware: 'auth',
      acl: [
        {
          name: 'create_master_data',
          permission: 'create'
        }
      ]
    },
    component: () => import('@/views/master_data/cost_consumer/form.vue')
  },
  {
    path: '/master_data/cost_consumer/detail/:id',
    name: 'costConsumerDetail',
    props: true,
    meta: {
      title: 'master data',
      middleware: 'auth',
      acl: [
        {
          name: 'view_master_data',
          permission: 'view'
        }
      ]
    },
    component: () => import('@/views/master_data/cost_consumer/detail.vue')
  },
  {
    path: '/master_data/cost_consumer/edit/:id',
    name: 'costConsumerEdit',
    props: true,
    meta: {
      title: 'master data',
      middleware: 'auth',
      acl: [
        {
          name: 'update_master_data',
          permission: 'update'
        }
      ]
    },
    component: () => import('@/views/master_data/cost_consumer/form.vue')
  },
  {
    path: '/master_data/stage',
    name: 'stage',
    meta: {
      title: 'master data',
      middleware: 'auth',
      acl: [
        {
          name: 'view_master_data',
          permission: 'view'
        }
      ]
    },
    component: () => import('@/views/master_data/stage/index.vue')
  },
  {
    path: '/master_data/cost-category',
    name: 'costCategory',
    meta: {
      title: 'master data',
      middleware: 'auth',
      acl: [
        {
          name: 'view_master_data',
          permission: 'view'
        }
      ]
    },
    component: () => import('@/views/master_data/cost_category/index.vue')
  },
  {
    path: '/master_data/unit',
    name: 'unit',
    meta: {
      title: 'master data',
      middleware: 'auth',
      acl: [
        {
          name: 'view_master_data',
          permission: 'view'
        }
      ]
    },
    component: () => import('@/views/master_data/unit/index.vue')
  },
  {
    path: '/user_management/user',
    name: 'user',
    meta: {
      title: 'user management',
      middleware: 'auth',
      acl: [
        {
          name: 'view_user',
          permission: 'view'
        }
      ]
    },
    component: () => import('@/views/user_management/user/index.vue')
  },
  {
    path: '/user_management/user/create',
    name: 'userCreate',
    meta: {
      title: 'user management',
      middleware: 'auth',
      acl: [
        {
          name: 'create_user',
          permission: 'create'
        }
      ]
    },
    component: () => import('@/views/user_management/user/form.vue')
  },
  {
    path: '/user_management/user/edit/:id',
    name: 'userEdit',
    props: true,
    meta: {
      title: 'user management',
      middleware: 'auth',
      acl: [
        {
          name: 'edit_user',
          permission: 'update'
        }
      ]
    },
    component: () => import('@/views/user_management/user/form.vue')
  },
  {
    path: '/user_management/user/detail/:id',
    name: 'userDetail',
    props: true,
    meta: {
      title: 'user management',
      middleware: 'auth',
      acl: [
        {
          name: 'view_user',
          permission: 'view'
        }
      ]
    },
    component: () => import('@/views/user_management/user/detail.vue')
  },
  {
    path: '/user_management/profile',
    name: 'profile',
    meta: {
      title: 'user management',
      middleware: 'auth',
      acl: [
        {
          name: 'view_profile',
          permission: 'view'
        }
      ]
    },
    component: () => import('@/views/user_management/profile/index.vue')
  },
  {
    path: '/user_management/profile/create',
    name: 'profileCreate',
    meta: {
      title: 'user management',
      middleware: 'auth',
      acl: [
        {
          name: 'create_profile',
          permission: 'create'
        }
      ]
    },
    component: () => import('@/views/user_management/profile/form.vue')
  },
  {
    path: '/user_management/profile/edit/:id',
    name: 'profileEdit',
    props: true,
    meta: {
      title: 'user management',
      middleware: 'auth',
      acl: [
        {
          name: 'edit_profile',
          permission: 'update'
        }
      ]
    },
    component: () => import('@/views/user_management/profile/form.vue')
  },
  {
    path: '/user_management/profile/detail/:id',
    name: 'profileDetail',
    props: true,
    meta: {
      title: 'user management',
      middleware: 'auth',
      acl: [
        {
          name: 'view_profile',
          permission: 'view'
        }
      ]
    },
    component: () => import('@/views/user_management/profile/detail.vue')
  },
  {
    path: '/master_data/division',
    name: 'division',
    meta: {
      title: 'master data',
      middleware: 'auth',
      acl: [
        {
          name: 'view_master_data',
          permission: 'view'
        }
      ]
    },
    component: () => import('@/views/master_data/division/index.vue')
  },
  {
    path: '/master_data/division/:id',
    name: 'divisionDetail',
    props: true,
    meta: {
      title: 'master data',
      middleware: 'auth',
      acl: [
        {
          name: 'view_master_data',
          permission: 'view'
        }
      ]
    },
    component: () => import('@/views/master_data/division/detail.vue')
  },
  {
    path: '/master_data/investment_type',
    name: 'investment_type',
    meta: {
      title: 'master data',
      middleware: 'auth',
      acl: [
        {
          name: 'view_master_data',
          permission: 'view'
        }
      ]
    },
    component: () => import('@/views/master_data/investment/index.vue')
  },
  {
    path: '/help-center',
    name: 'content-management',
    meta: {
      title: 'content management',
      guideline: true,
      middleware: 'auth'
    },
    component: () => import('@/views/content_management/cms/index.vue')
  },
  {
    path: '/help-center/faq',
    name: 'help-center-faq',
    meta: {
      title: 'content management',
      guideline: true,
      middleware: 'auth'
    },
    component: () => import('@/views/content_management/cms/faq.vue')
  },
  {
    path: '/help-center/guideline',
    name: 'content-management-text',
    meta: {
      title: 'content management',
      guideline: true,
      middleware: 'auth'
    },
    component: () => import('@/views/content_management/cms/cms_text.vue')
  },
  {
    path: '/content-management/cms-docs',
    name: 'docs',
    meta: {
      title: 'content management',
      middleware: 'auth',
      acl: [
        {
          name: 'view_master_data',
          permission: 'view'
        }
      ]
    },
    component: () => import('@/views/content_management/cms_docs/index.vue')
  },
  {
    path: '/content-management/cms-docs/:type/:id',
    name: 'docsDetail',
    props: true,
    meta: {
      title: 'content management',
      middleware: 'auth',
      acl: [
        {
          name: 'view_master_data',
          permission: 'view'
        }
      ]
    },
    component: () => import('@/views/content_management/cms_docs/form.vue')
  },
  {
    path: '/content-management/cms-docs/create',
    name: 'docsCreate',
    meta: {
      title: 'content management',
      middleware: 'auth',
      acl: [
        {
          name: 'create_master_data',
          permission: 'create'
        }
      ]
    },
    component: () => import('@/views/content_management/cms_docs/form.vue')
  },
  {
    path: '/content-management/cms-docs/:type/:id',
    name: 'docsEdit',
    props: true,
    meta: {
      title: 'content management',
      middleware: 'auth',
      acl: [
        {
          name: 'update_master_data',
          permission: 'update'
        }
      ]
    },
    component: () => import('@/views/content_management/cms_docs/form.vue')
  },
  {
    path: '/content-management/cms-text',
    name: 'cmsText',
    meta: {
      title: 'content management',
      middleware: 'auth',
      acl: [
        {
          name: 'view_master_data',
          permission: 'view'
        }
      ]
    },
    component: () => import('@/views/content_management/cms_text/index.vue')
  },
  {
    path: '/content-management/cms-text/:type/:id',
    name: 'cmsTextDetail',
    props: true,
    meta: {
      title: 'content management',
      middleware: 'auth',
      acl: [
        {
          name: 'view_master_data',
          permission: 'view'
        }
      ]
    },
    component: () => import('@/views/content_management/cms_text/form.vue')
  },
  {
    path: '/content-management/cms-text/create',
    name: 'cmsTextCreate',
    meta: {
      title: 'content management',
      middleware: 'auth',
      acl: [
        {
          name: 'create_master_data',
          permission: 'create'
        }
      ]
    },
    component: () => import('@/views/content_management/cms_text/form.vue')
  },
  {
    path: '/content-management/cms-text/:type/:id',
    name: 'cmsTextEdit',
    props: true,
    meta: {
      title: 'content management',
      middleware: 'auth',
      acl: [
        {
          name: 'update_master_data',
          permission: 'update'
        }
      ]
    },
    component: () => import('@/views/content_management/cms_text/form.vue')
  },
  {
    path: '/content-management/cms-menu',
    name: 'cmsMenu',
    meta: {
      title: 'content management',
      middleware: 'auth',
      acl: [
        {
          name: 'view_master_data',
          permission: 'view'
        }
      ]
    },
    component: () => import('@/views/content_management/cms_menu/index.vue')
  },
  {
    path: '/content-management/cms-menu/:type/:id',
    name: 'cmsMenuDetail',
    props: true,
    meta: {
      title: 'content management',
      middleware: 'auth',
      acl: [
        {
          name: 'view_master_data',
          permission: 'view'
        }
      ]
    },
    component: () => import('@/views/content_management/cms_menu/form.vue')
  },
  {
    path: '/content-management/faq',
    name: 'faq',
    meta: {
      title: 'content management',
      middleware: 'auth',
      acl: [
        {
          name: 'view_master_data',
          permission: 'view'
        }
      ]
    },
    component: () => import('@/views/content_management/faq/index.vue')
  },
  {
    path: '/content-management/faq/create',
    name: 'faqCreate',
    meta: {
      title: 'content management',
      middleware: 'auth',
      acl: [
        {
          name: 'view_master_data',
          permission: 'view'
        }
      ]
    },
    component: () => import('@/views/content_management/faq/form.vue')
  },
  {
    path: '/content-management/faq/:type/:id',
    name: 'faqEdit',
    props: true,
    meta: {
      title: 'content management',
      middleware: 'auth',
      acl: [
        {
          name: 'view_master_data',
          permission: 'view'
        }
      ]
    },
    component: () => import('@/views/content_management/faq/form.vue')
  },
  {
    path: '/content-management/:type/:id',
    name: 'faqDetail',
    props: true,
    meta: {
      title: 'content management',
      middleware: 'auth',
      acl: [
        {
          name: 'view_master_data',
          permission: 'view'
        }
      ]
    },
    component: () => import('@/views/content_management/faq/form.vue')
  },
  {
    path: '/master-data/faq-category',
    name: 'faqCategory',
    meta: {
      title: 'master data',
      middleware: 'auth',
      acl: [
        {
          name: 'view_master_data',
          permission: 'view'
        }
      ]
    },
    component: () => import('@/views/master_data/category/index.vue')
  },
  {
    path: '/help-center/support',
    name: 'Support',
    meta: {
      title: 'Help Center',
      guideline: true,
      middleware: 'auth'
    },
    component: () => import('@/views/content_management/support/index.vue')
  },
  {
    path: '/audit-trail/user-management',
    name: 'audit-trail-user',
    meta: {
      title: 'Audit Trail',
      middleware: 'auth',
      acl: [
        {
          name: 'view_audit_trail',
          permission: 'view'
        }
      ]
    },
    component: () => import('@/views/audit_trail/user_management')
  },
  {
    path: '/audit-trail/master-data',
    name: 'audit-trail-master-data',
    meta: {
      title: 'Audit Trail',
      middleware: 'auth',
      acl: [
        {
          name: 'view_audit_trail',
          permission: 'view'
        }
      ]
    },
    component: () => import('@/views/audit_trail/master_data')
  },
  {
    path: '/audit-trail/lock-budget',
    name: 'audit-trail-lock-budget',
    meta: {
      title: 'Audit Trail',
      middleware: 'auth',
      acl: [
        {
          name: 'view_audit_trail',
          permission: 'view'
        }
      ]
    },
    component: () => import('@/views/audit_trail/lock_budget')
  },
  {
    path: '/audit-trail/login',
    name: 'audit-trail-login',
    props: true,
    meta: {
      title: 'Audit Trail',
      middleware: 'auth',
      acl: [
        {
          name: 'view_audit_trail',
          permission: 'view'
        }
      ]
    },
    component: () => import('@/views/audit_trail/lock_budget')
  },
  {
    path: '/audit-trail/dynamic-hierarchy',
    name: 'audit-trail-dynamic-hierarchy',
    meta: {
      title: 'Audit Trail',
      middleware: 'auth',
      acl: [
        {
          name: 'view_audit_trail',
          permission: 'view'
        }
      ]
    },
    component: () => import('@/views/audit_trail/hierarchy')
  },
  {
    path: '/audit-trail/group',
    name: 'audit-trail-group',
    meta: {
      title: 'Audit Trail',
      middleware: 'auth',
      acl: [
        {
          name: 'view_audit_trail',
          permission: 'view'
        }
      ]
    },
    component: () => import('@/views/audit_trail/group')
  },
  {
    path: '/budgeting/report/add',
    name: 'reportAdd',
    meta: {
      title: 'budgeting',
      middleware: 'auth',
      acl: [
        {
          name: 'create_budget',
          permission: 'create'
        }
      ]
    },
    component: () => import('@/views/budgeting/form.vue')
  },
  {
    path: '/budgeting/report/add-cut',
    name: 'reportAddCut',
    meta: {
      title: 'budgeting',
      middleware: 'auth',
      acl: [
        {
          name: 'create_budget',
          permission: 'create'
        }
      ]
    },
    component: () => import('@/views/budgeting/form_cut.vue')
  },
  {
    path: '/configuration/adhoc',
    name: 'config-adhoc',
    meta: {
      title: 'configuration',
      middleware: 'auth',
      acl: [
        {
          name: 'adhoc_config',
          permission: 'update'
        }
      ]
    },
    component: () => import('@/views/configuration/adhoc/index.vue')
  },
  {
    path: '/configuration/quarter',
    name: 'config-quarter',
    meta: {
      title: 'configuration',
      middleware: 'auth',
      acl: [
        {
          name: 'config',
          permission: 'update'
        }
      ]
    },
    component: () => import('@/views/configuration/config_quarter/index.vue')
  },
  {
    path: '/configuration/spending-tolerance',
    name: 'spending-tolerance',
    meta: {
      title: 'configuration',
      middleware: 'auth',
      acl: [
        {
          name: 'config',
          permission: 'update'
        }
      ]
    },
    component: () =>
      import('@/views/configuration/spending_tolerance/index.vue')
  },
  {
    path: '/configuration/password',
    name: 'config-password',
    meta: {
      title: 'configuration',
      middleware: 'auth',
      acl: [
        {
          name: 'compability_password',
          permission: 'update'
        }
      ]
    },
    component: () => import('@/views/configuration/password/index.vue')
  },
  {
    path: '/configuration/upload-po',
    name: 'automatic-upload-po',
    meta: {
      title: 'configuration',
      middleware: 'auth',
      acl: [
        {
          name: 'po_automated_calendar',
          permission: 'update'
        }
      ]
    },
    component: () =>
      import('@/views/configuration/automatic_upload/po_monitoring')
  },
  {
    path: '/configuration/upload-nonpo',
    name: 'automatic-upload-nonpo',
    meta: {
      title: 'configuration',
      middleware: 'auth',
      acl: [
        {
          name: 'po_automated_calendar',
          permission: 'update'
        }
      ]
    },
    component: () => import('@/views/configuration/automatic_upload/non_po')
  },
  {
    path: '/configuration/email-support',
    name: 'email-support',
    meta: {
      title: 'configuration',
      middleware: 'auth',
      acl: [
        {
          name: 'config_email_help_center',
          permission: 'update'
        }
      ]
    },
    component: () => import('@/views/configuration/email_support/index.vue')
  },
  {
    path: '/configuration/lock-budget',
    name: 'lock-budget',
    meta: {
      title: 'configuration',
      middleware: 'auth',
      acl: [
        {
          name: 'config_lock_budget',
          permission: 'view'
        }
      ]
    },
    component: () => import('@/views/configuration/budget/index.vue')
  },
  {
    path: '/key-highlight',
    name: 'keyHighlight',
    meta: {
      title: 'Key Highlight',
      middleware: 'auth',
      acl: [
        {
          name: 'key_highlight',
          permission: 'view'
        }
      ]
    },
    component: () => import('@/views/key_highlight')
  },
  {
    path: '/key-highlight/create',
    name: 'keyHighlightCreate',
    meta: {
      title: 'Key Highlight',
      middleware: 'auth',
      acl: [
        {
          name: 'key_highlight',
          permission: 'view'
        }
      ]
    },
    component: () => import('@/views/key_highlight/form.vue')
  },
  {
    path: '/key-highlight/edit/:id',
    name: 'keyHighlightEdit',
    props: true,
    meta: {
      title: 'Key Highlight',
      middleware: 'auth',
      acl: [
        {
          name: 'key_highlight',
          permission: 'view'
        }
      ]
    },
    component: () => import('@/views/key_highlight/form.vue')
  },
  {
    path: '/key-highlight/:id',
    name: 'keyHighlightDetail',
    props: true,
    meta: {
      title: 'Key Highlight',
      middleware: 'auth',
      acl: [
        {
          name: 'key_highlight',
          permission: 'view'
        }
      ]
    },
    component: () => import('@/views/key_highlight/detail.vue')
  },
  {
    path: '/monthly-report/topline/:id',
    name: 'monthly-topline-report',
    props: true,
    meta: {
      title: 'Monthly Report',
      middleware: 'auth',
      acl: [
        {
          name: 'view_monthly_topline_report',
          permission: 'view'
        }
      ]
    },
    component: () => import('@/views/monthly_report/topline_report')
  },
  {
    path: '/monthly-report/consolidated-po/:id',
    name: 'consolidated-report-po',
    props: true,
    meta: {
      title: 'Monthly Report',
      middleware: 'auth',
      acl: [
        {
          name: 'view_monthly_consolidate_report',
          permission: 'view'
        }
      ]
    },
    component: () => import('@/views/monthly_report/consolidate_PO')
  },
  // SSHCF
  {
    path: '/sshcf/dashboard',
    name: 'sshcf_dashboard',
    props: true,
    meta: {
      title: 'SSHCF',
      middleware: 'auth',
      acl: [
        {
          name: 'dashboard_sshcf',
          permission: 'view'
        }
      ]
    },
    component: () => import('@/views/sshcf/Dashboard.vue')
  },
  {
    path: '/mroi/shopper-activities',
    name: 'mroi-shopper',
    meta: {
      title: 'MROI',
      middleware: 'auth',
      acl: [
        {
          name: 'view_mroi',
          permission: 'view'
        }
      ]
    },
    component: () => import('@/views/mroi/shopper.vue')
  },
  {
    path: '/sshcf/import-users',
    name: 'sshcf_import_users',
    props: true,
    meta: {
      title: 'SSHCF',
      middleware: 'auth',
      acl: [
        // {
        //   name: 'dashboard_sshcf',
        //   permission: 'view'
        // }
      ]
    },
    component: () => import('@/views/sshcf/ImportUsers.vue')
  },
  {
    path: '/sshcf/detail/:id',
    name: 'sshcf_detail',
    props: true,
    meta: {
      title: 'SSHCF',
      middleware: 'auth',
      acl: [
        {
          name: 'dashboard_sshcf',
          permission: 'view'
        }
      ]
    },
    component: () => import('@/views/sshcf/Detail.vue')
  },
  {
    path: '/sshcf/requests',
    name: 'sshcf_requests',
    props: true,
    meta: {
      title: 'SSHCF',
      middleware: 'auth',
      acl: [
        {
          name: 'request_sshcf',
          permission: 'create'
        }
      ]
    },
    component: () => import('@/views/sshcf/Requests.vue')
  },
  {
    path: '/sshcf/requests/create',
    name: 'sshcf_requests_create',
    props: true,
    meta: {
      title: 'SSHCF',
      middleware: 'auth',
      isRequireAccess: true,
      acl: [
        {
          name: 'request_sshcf',
          permission: 'create'
        }
      ]
    },
    component: () => import('@/views/sshcf/FormRequest.vue')
  },
  {
    path: '/sshcf/regions',
    name: 'sshcf_regions',
    props: true,
    meta: {
      title: 'SSHCF',
      middleware: 'auth',
      acl: [
        {
          name: 'view_master_data_sshcf',
          permission: 'view'
        }
      ]
    },
    component: () => import('@/views/master_data/sshcf/regions.vue')
  },
  {
    path: '/sshcf/sponsorship/reports',
    name: 'sshcf_sponsorship_reports',
    props: true,
    meta: {
      title: 'SSHCF',
      middleware: 'auth',
      acl: [
        {
          name: 'sponsorship_reports_sshcf',
          permission: 'create'
        }
      ]
    },
    component: () => import('@/views/sshcf/SponsorshipReports.vue')
  },
  {
    path: '/sshcf/sla',
    name: 'sshcf_sla',
    props: true,
    meta: {
      title: 'SSHCF',
      middleware: 'auth',
      acl: [
        {
          name: 'sla_reports_sshcf',
          permission: 'create'
        }
      ]
    },
    component: () => import('@/views/sshcf/SlaReports.vue')
  },
  {
    path: '/sshcf/sla/:id',
    name: 'sshcf_sla_detail',
    props: true,
    meta: {
      title: 'SSHCF',
      middleware: 'auth',
      acl: [
        {
          name: 'sla_reports_sshcf',
          permission: 'create'
        }
      ]
    },
    component: () => import('@/views/sshcf/SlaReportsDetail.vue')
  },
  {
    path: '/sshcf/request/:id',
    name: 'sshcf_request_detail',
    props: true,
    meta: {
      title: 'SSHCF',
      middleware: 'auth',
      acl: [
        {
          name: 'sla_reports_sshcf',
          permission: 'create'
        }
      ]
    },
    component: () => import('@/views/sshcf/FormRequest.vue')
  },
  {
    path: '/sshcf/districts',
    props: true,
    meta: {
      title: 'SSHCF',
      middleware: 'auth',
      acl: [
        {
          name: 'view_master_data_sshcf',
          permission: 'view'
        }
      ]
    },
    component: () => import('@/views/master_data/sshcf/districts.vue')
  },
  {
    path: '/sshcf/login',
    props: true,
    meta: {
      title: 'SSHCF',
      middleware: 'auth',
      acl: [
        // {
        //   name: 'view_master_data_sshcf',
        //   permission: 'view'
        // }
      ]
    },
    component: () => import('@/views/sshcf/Login.vue')
  },
  {
    path: '/sshcf/plants',
    props: true,
    meta: {
      title: 'SSHCF',
      middleware: 'auth',
      acl: [
        {
          name: 'view_master_data_sshcf',
          permission: 'view'
        }
      ]
    },
    component: () => import('@/views/master_data/sshcf/plants.vue')
  },
  {
    path: '/sshcf/hospitals',
    props: true,
    meta: {
      title: 'SSHCF',
      middleware: 'auth',
      acl: [
        {
          name: 'view_master_data_sshcf',
          permission: 'view'
        }
      ]
    },
    component: () => import('@/views/master_data/sshcf/hospitals.vue')
  },
  {
    path: '/sshcf/vendors',
    props: true,
    meta: {
      title: 'SSHCF',
      middleware: 'auth',
      acl: [
        {
          name: 'view_master_data_sshcf',
          permission: 'view'
        }
      ]
    },
    component: () => import('@/views/master_data/sshcf/vendors.vue')
  },
  {
    path: '/monthly-report/consolidated-io/:id',
    name: 'consolidated-report-io',
    props: true,
    meta: {
      title: 'Monthly Report',
      middleware: 'auth',
      acl: [
        {
          name: 'view_monthly_consolidate_report',
          permission: 'view'
        }
      ]
    },
    component: () => import('@/views/monthly_report/consolidate_IO')
  },
  {
    path: '/sshcf/companies',
    props: true,
    meta: {
      title: 'SSHCF',
      middleware: 'auth',
      acl: [
        {
          name: 'view_master_data_sshcf',
          permission: 'view'
        }
      ]
    },
    component: () => import('@/views/master_data/sshcf/companies.vue')
  },
  {
    path: '/power_bi',
    name: 'power_bi',
    props: true,
    meta: {
      title: 'POWER BI',
      middleware: 'auth',
      acl: [
        {
          name: 'power_bi',
          permission: 'view'
        }
      ]
    },
    component: () => import('@/views/power_bi/index.vue')
  },
  {
    path: '/financial-portal/content-config',
    name: 'finance-portal-content-config',
    meta: {
      title: 'financial Portal',
      middleware: 'auth',
      acl: [
        {
          name: 'finance_portal_config',
          permission: 'create'
        }
      ]
    },
    component: () => import('@/views/finance_portal/config')
  },
  {
    path: '/financial-portal/content-config/:type/:id',
    name: 'finance-portal-content-config-detail',
    props: true,
    meta: {
      title: 'financial portal',
      middleware: 'auth',
      acl: [
        {
          name: 'finance_portal_config',
          permission: 'create'
        }
      ]
    },
    component: () => import('@/views/finance_portal/config/form.vue')
  },
  {
    path: '/financial-portal/guidebook-docs',
    name: 'guidebook-docs',
    meta: {
      title: 'Financial Portal',
      middleware: 'auth',
      acl: [
        {
          name: 'finance_portal_config',
          permission: 'create'
        }
      ]
    },
    component: () => import('@/views/finance_portal/guidebook')
  },
  {
    path: '/financial-portal/portal',
    name: 'financial-portal',
    props: true,
    meta: {
      title: 'Financial Portal',
      middleware: 'auth',
      acl: [
        {
          name: 'finance_portal_view',
          permission: 'view'
        }
      ]
    },
    component: () => import('@/views/finance_portal/portal')
  },
  {
    path: '/organization-management/dynamic-hierarchy',
    name: 'dynamic-hierarchy',
    meta: {
      title: 'Organization Management',
      middleware: 'auth',
      acl: [
        {
          name: 'view_master_data',
          permission: 'view'
        }
      ]
    },
    component: () => import('@/views/dynamic_hierarchy/index.vue')
  },
  {
    path: '/organization-management/dynamic-hierarchy/:type',
    name: 'dynamic-hierarchy-create',
    props: true,
    meta: {
      title: 'Organization Management',
      middleware: 'auth',
      acl: [
        {
          name: 'view_master_data',
          permission: 'view'
        }
      ]
    },
    component: () => import('@/views/dynamic_hierarchy/form.vue')
  },
  {
    path: '/organization-management/dynamic-hierarchy/:type/:id',
    name: 'dynamic-hierarchy-edit',
    props: true,
    meta: {
      title: 'Organization Management',
      middleware: 'auth',
      acl: [
        {
          name: 'view_master_data',
          permission: 'view'
        }
      ]
    },
    component: () => import('@/views/dynamic_hierarchy/form.vue')
  },
  {
    path: '/organization-management/draft/dynamic-hierarchy/:type/:id',
    name: 'draft-hierarchy-edit',
    props: true,
    meta: {
      title: 'Organization Management',
      middleware: 'auth',
      acl: [
        {
          name: 'view_master_data',
          permission: 'view'
        }
      ]
    },
    component: () => import('@/views/dynamic_hierarchy/form.vue')
  },
  {
    path: '/organization-management/dynamic-hierarchy/:id',
    name: 'dynamic-hierarchy-detail',
    props: true,
    meta: {
      title: 'Organization Management',
      middleware: 'auth',
      acl: [
        {
          name: 'view_master_data',
          permission: 'view'
        }
      ]
    },
    component: () => import('@/views/dynamic_hierarchy/detail.vue')
  },
  {
    path: '/organization-management/draft/dynamic-hierarchy/:id',
    name: 'draft-hierarchy-detail',
    props: true,
    meta: {
      title: 'Organization Management',
      middleware: 'auth',
      acl: [
        {
          name: 'view_master_data',
          permission: 'view'
        }
      ]
    },
    component: () => import('@/views/dynamic_hierarchy/detail.vue')
  },
  {
    path: '/organization-management/group',
    name: 'group',
    meta: {
      title: 'Organization Management',
      middleware: 'auth',
      acl: [
        {
          name: 'view_master_data',
          permission: 'view'
        }
      ]
    },
    component: () => import('@/views/dynamic_hierarchy/group/index.vue')
  },
  {
    path: '/organization-management/draft/dynamic-hierarchy',
    name: 'draft-hierarchy',
    meta: {
      title: 'Organization Management',
      middleware: 'auth',
      acl: [
        {
          name: 'view_master_data',
          permission: 'view'
        }
      ]
    },
    component: () => import('@/views/dynamic_hierarchy/index.vue')
  },
  {
    path: '/organization-management/approval',
    name: 'dynamic-approval',
    meta: {
      title: 'Organization Management',
      middleware: 'auth',
      acl: [
        {
          name: 'view_master_data',
          permission: 'view'
        }
      ]
    },
    component: () => import('@/views/dynamic_hierarchy/approval/index.vue')
  },
  {
    path: '/organization-management/approval/:type/:id',
    name: 'dynamic-approval-form',
    props: true,
    meta: {
      title: 'Organization Management',
      middleware: 'auth',
      acl: [
        {
          name: 'view_master_data',
          permission: 'view'
        }
      ]
    },
    component: () => import('@/views/dynamic_hierarchy/approval/form.vue')
  },
  // SSCHP
  {
    path: '/sshcp/dashboard',
    name: 'sshcp_dashboard',
    props: true,
    meta: {
      title: 'SSHCP',
      middleware: 'auth',
      acl: [
        {
          name: 'dashboard_sshcp',
          permission: 'view'
        }
      ]
    },
    component: () => import('@/views/sshcp/Dashboard.vue')
  },
  {
    path: '/sshcp/regions',
    name: 'sshcp_regions',
    props: true,
    meta: {
      title: 'SSHCP',
      middleware: 'auth',
      acl: [
        {
          name: 'view_sshcp_master_data',
          permission: 'view'
        }
      ]
    },
    component: () => import('@/views/sshcp/master_data/region/regions.vue')
  },
  {
    path: '/sshcp/regions/master-data',
    name: 'master-regions',
    props: true,
    meta: {
      title: 'SSHCP',
      middleware: 'auth',
      acl: [
        {
          name: 'view_sshcp_master_data',
          permission: 'view'
        }
      ]
    },
    component: () =>
      import('@/views/sshcp/master_data/region/masterRegions.vue')
  },
  {
    path: '/sshcp/districts',
    name: 'sshcp_districts',
    props: true,
    meta: {
      title: 'SSHCP',
      middleware: 'auth',
      acl: [
        {
          name: 'view_sshcp_master_data',
          permission: 'view'
        }
      ]
    },
    component: () => import('@/views/sshcp/master_data/district/districts.vue')
  },
  {
    path: '/sshcp/districts/master-data',
    name: 'master-districts',
    props: true,
    meta: {
      title: 'SSHCP',
      middleware: 'auth',
      acl: [
        {
          name: 'view_sshcp_master_data',
          permission: 'view'
        }
      ]
    },
    component: () =>
      import('@/views/sshcp/master_data/district/masterDistricts.vue')
  },
  {
    path: '/sshcp/groups',
    name: 'master-groups',
    props: true,
    meta: {
      title: 'SSHCP',
      middleware: 'auth',
      acl: [
        {
          name: 'view_sshcp_master_data',
          permission: 'view'
        }
      ]
    },
    component: () => import('@/views/sshcp/master_data/group/index.vue')
  },
  {
    path: '/sshcp/vendors',
    name: 'master-vendors',
    props: true,
    meta: {
      title: 'SSHCP',
      middleware: 'auth',
      acl: [
        {
          name: 'view_sshcp_master_data',
          permission: 'view'
        }
      ]
    },
    component: () => import('@/views/sshcp/master_data/vendor/index.vue')
  },
  {
    path: '/sshcp/activities',
    name: 'master-activities',
    props: true,
    meta: {
      title: 'SSHCP',
      middleware: 'auth',
      acl: [
        {
          name: 'view_sshcp_master_data',
          permission: 'view'
        }
      ]
    },
    component: () => import('@/views/sshcp/master_data/activities/index.vue')
  },
  {
    path: '/sshcp/request/pending',
    name: 'pending_approval',
    props: true,
    meta: {
      title: 'SSHCP',
      middleware: 'auth',
      acl: [
        {
          name: 'view_form_request_sshcp',
          permission: 'view'
        }
      ]
    },
    component: () => import('@/views/sshcp/request/pending_approval/index.vue')
  },
  {
    path: '/sshcp/request',
    name: 'sshcp_request',
    props: true,
    meta: {
      title: 'SSHCP',
      middleware: 'auth',
      acl: [
        {
          name: 'view_form_request_sshcp',
          permission: 'view'
        }
      ]
    },
    component: () => import('@/views/sshcp/request/index.vue')
  },
  {
    path: '/sshcp/request/:id',
    name: 'sshcp_request_detail',
    props: true,
    meta: {
      title: 'SSHCP',
      middleware: 'auth',
      acl: [
        {
          name: 'create_form_request_sshcp',
          permission: 'create'
        }
      ]
    },
    component: () => import('@/views/sshcp/request/form.vue')
  },
  {
    path: '/sshcp/request/detail/:id',
    name: 'sshcp_hcp_detail',
    props: true,
    meta: {
      title: 'SSHCP',
      middleware: 'auth',
      acl: [
        {
          name: 'view_form_request_sshcp',
          permission: 'view'
        }
      ]
    },
    component: () => import('@/views/sshcp/request/detail.vue')
  },
  {
    path: '/sshcp/requests/history',
    name: 'sshcp_history',
    props: false,
    meta: {
      title: 'SSHCP',
      middleware: 'auth',
      acl: [
        {
          name: 'view_form_request_sshcp',
          permission: 'view'
        }
      ]
    },
    component: () => import('@/views/sshcp/request/history/index.vue')
  },
  {
    path: '/sshcp/requests/history/:id',
    name: 'sshcp_history_detail',
    props: true,
    meta: {
      title: 'SSHCP',
      middleware: 'auth',
      acl: [
        {
          name: 'view_form_request_sshcp',
          permission: 'view'
        }
      ]
    },
    component: () => import('@/views/sshcp/request/history/detail.vue')
  },
  {
    path: '/sshcp/requests/create',
    name: 'sshcp_request_form',
    props: true,
    meta: {
      title: 'SSHCP',
      middleware: 'auth',
      acl: [
        {
          name: 'create_form_request_sshcp',
          permission: 'create'
        }
      ]
    },
    component: () => import('@/views/sshcp/request/form.vue')
  },
  {
    path: '/sshcp/budget-mapping',
    name: 'sshcp_budget_mapping',
    props: true,
    meta: {
      title: 'SSHCP',
      middleware: 'auth',
      acl: [
        {
          name: 'view_budget_mapping_sshcp',
          permission: 'view'
        }
      ]
    },
    component: () => import('@/views/sshcp/BudgetMapping.vue')
  },
  {
    path: '/sshcp/approval/user',
    name: 'sshcp_user_mapping',
    props: true,
    meta: {
      title: 'SSHCP',
      middleware: 'auth',
      acl: [
        {
          name: 'view_approval_management_sshcp',
          permission: 'view'
        }
      ]
    },
    component: () => import('@/views/sshcp/approval/user_mapping/index.vue')
  },
  {
    path: '/sshcp/approval/user/create',
    name: 'sshcp_create_user_mapping',
    props: true,
    meta: {
      title: 'SSHCP',
      middleware: 'auth',
      acl: [
        {
          name: 'create_approval_management_sshcp',
          permission: 'create'
        }
      ]
    },
    component: () => import('@/views/sshcp/approval/user_mapping/form.vue')
  },
  {
    path: '/sshcp/approval/user/:id',
    name: 'sshcp_update_user_mapping',
    props: true,
    meta: {
      title: 'SSHCP',
      middleware: 'auth',
      acl: [
        {
          name: 'create_approval_management_sshcp',
          permission: 'create'
        }
      ]
    },
    component: () => import('@/views/sshcp/approval/user_mapping/form.vue')
  },
  {
    path: '/sshcp/approval/user-import',
    name: 'sshcp_import_user_mapping',
    props: true,
    meta: {
      title: 'SSHCP',
      middleware: 'auth'
    },
    component: () => import('@/views/sshcp/approval/user_mapping/import.vue')
  },
  {
    path: '/sshcp/approval/mapping',
    name: 'sshcp_approval_mapping',
    props: true,
    meta: {
      title: 'SSHCP',
      middleware: 'auth',
      acl: [
        {
          name: 'view_approval_management_sshcp',
          permission: 'view'
        }
      ]
    },
    component: () => import('@/views/sshcp/approval/approval_mapping/index.vue')
  },
  {
    path: '/sshcp/approval/mapping/edit/:id',
    name: 'sshcp_create_approval_mapping',
    props: true,
    meta: {
      title: 'SSHCP',
      middleware: 'auth',
      acl: [
        {
          name: 'create_approval_management_sshcp',
          permission: 'create'
        }
      ]
    },
    component: () => import('@/views/sshcp/approval/approval_mapping/form.vue')
  },
  {
    path: '/sshcp/approval/import',
    name: 'sshcp_import_approval',
    props: true,
    meta: {
      title: 'SSHCP',
      middleware: 'auth'
    },
    component: () =>
      import('@/views/sshcp/approval/approval_mapping/import.vue')
  },
  {
    path: '/sshcp/sla',
    name: 'sshcp_sla_report',
    props: true,
    meta: {
      title: 'SSHCP',
      middleware: 'auth',
      acl: [
        {
          name: 'view_sla_sshcp',
          permission: 'view'
        }
      ]
    },
    component: () => import('@/views/sshcp/sla_report/index.vue')
  },
  {
    path: '/sshcp/sla/:id',
    name: 'sshcp_sla_detail',
    props: true,
    meta: {
      title: 'SSHCP',
      middleware: 'auth',
      acl: [
        {
          name: 'view_sla_sshcp',
          permission: 'view'
        }
      ]
    },
    component: () => import('@/views/sshcp/sla_report/detail.vue')
  },
  {
    path: '/sshcp/re-route',
    name: 'sshcp_reroute',
    props: true,
    meta: {
      title: 'SSHCP',
      middleware: 'auth',
      acl: [
        {
          name: 'view_sshcp_master_data',
          permission: 'view'
        }
      ]
    },
    component: () => import('@/views/sshcp/re_route/index.vue')
  },
  // NOT FOUND
  {
    path: '*',
    name: 'NotFound',
    component: () => import('@/components/notfound.vue')
  },
  {
    path: '/unauthorized',
    name: 'unauthorized',
    component: () => import('@/components/unauthorized.vue')
  }
];
